/* Customily injects #customily-preview-button into .product-form__buttons
   (alongside the theme's add-to-cart). Move it INSIDE #cl_optionsapp so
   the gray personalization card visually contains the preview action,
   matching the Customall product layout (where .btn-preview sits inside
   .ctm-customize-product). */
(function () {
  var LOG = '[customily-preview-mover]';

  function movePreviewIntoCard() {
    var card = document.querySelector('#cl_optionsapp');
    var btn = document.querySelector('#customily-preview-button');
    if (!card || !btn) return false;
    if (card.contains(btn)) return true;
    try {
      card.appendChild(btn);
      console.log(LOG, 'moved #customily-preview-button into #cl_optionsapp');
      return true;
    } catch (e) {
      console.error(LOG, 'move failed:', e);
      return false;
    }
  }

  function init() {
    console.log(LOG, 'init');
    movePreviewIntoCard();

    /* Customily mounts asynchronously and may re-render the button on
       variant change. Watch the DOM for ~60s and keep moving as needed. */
    var observer = new MutationObserver(movePreviewIntoCard);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
